import React from 'react';

const icons = require.context('!!@svgr/webpack!../../OneShell/Sidebar/icons', false, /\.svg$/);

const iconMap = icons.keys().reduce((map, path) => {
  const name = path.replace('./', '').replace('.svg', '');
  map[name] = icons(path).default;
  return map;
}, {});

const IconesMenu = ({ name, ...props }) => {
  const IconComponent = iconMap[name];
  return IconComponent ? <IconComponent {...props} /> : <span>❓</span>;
};

export default IconesMenu;
